import { render, staticRenderFns } from "./detail-solde-de-recuperation.vue?vue&type=template&id=5289b943&scoped=true"
import script from "./detail-solde-de-recuperation.vue?vue&type=script&lang=js"
export * from "./detail-solde-de-recuperation.vue?vue&type=script&lang=js"
import style0 from "./detail-solde-de-recuperation.vue?vue&type=style&index=0&id=5289b943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5289b943",
  null
  
)

export default component.exports